import type { OperationContext, OperationResult } from "urql"
import { useMutation } from "urql"

import type { CompanyMutationUpdateArgs, Mutation } from "@/graphql/codegen/graphql"
import { UpdateNewCompanyMutationDocument } from "@/graphql/codegen/graphql"

export const useCompanyCustomerAccountMutation = (): {
  updateCustomerAccountStatus: (
    variables: CompanyMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "company">, CompanyMutationUpdateArgs>>
} => {
  const [, updateCustomerAccountStatus] = useMutation<Pick<Mutation, "company">, CompanyMutationUpdateArgs>(
    UpdateNewCompanyMutationDocument
  )

  return {
    updateCustomerAccountStatus,
  }
}
